// extracted by mini-css-extract-plugin
export default {"kpiStatus":"KPIStatusIndicator_kpiStatus__1VykT"};